export type PaymentState = "draft" | "initiated" | "pending" | "paid" | "error" | "cancelled";

export interface PaymentReglementInfos {
  email: string;
  phone?: string;
  name: string;
  first_name?: string;
}

export interface Payment {
  id: string;
  ordre_id: string;
  org_id: string;
  type: "acompte" | "solde";
  amount: number;
  state: PaymentState;
  reglement_infos: PaymentReglementInfos;
  bridge?: {
    payment_link_id?: string;
    payment_link_url?: string;
    status?: string;
    status_reason?: string;
  };
  created_at: string;
  paid_at?: string;
  /** True when settled/recorded outside Bridge (cash, cheque, transfer, card terminal). */
  manual?: boolean;
  method?: PaymentMethod;
  note?: string;
}

export type PaymentMethod = "especes" | "cheque" | "virement" | "cb" | "autre";

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  especes: "Espèces",
  cheque: "Chèque",
  virement: "Virement",
  cb: "Carte bancaire",
  autre: "Autre",
};

export interface Facture {
  id: string;
  name: string;
  gcs_path: string;
  url: string;
  created_at: string;
  ordre_id: string;
  ordre_num: string;
  ordre_name: string;
  amount?: number;
}
